import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import firebase from 'firebase';

import NewEntryWidget from './NewEntryWidget';
import EntryView from './EntryView';

const styles = {
  root: {
    width: '100%',
  },
  listView: {
    maxWidth: '500px',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: '8px 8px',
  }
};

function EntryItem(props) {

}

class JournalView extends Component {
  state = {
    entries: [],
  }

  componentDidMount() {
    firebase.firestore().collection('users').doc(firebase.auth().currentUser.uid)
      .collection('entries')
      .orderBy('createdAt', 'desc')
      .limit(10)
      .onSnapshot(querySnapshot => {
        var entries = [];

        querySnapshot.forEach(doc => {
          entries.push(doc);
        });

        // check for missing entry today and add if needed
        var dayChange = new Date();
        if (dayChange.getHours() < 3) {
          dayChange.setDate(dayChange.getDate()-1);
        }
        dayChange.setHours(3); // assume new day begins at 3am local time

        // hack: pretend it's tomorrow
        // dayChange.setDate(dayChange.getDate()+1);

        if (entries.length > 0 && entries[0].data().createdAt < dayChange) {
          console.log(entries[0].data().createdAt);
          if (entries[0].data().createdAt != null) {
            var newEntryRef = firebase.firestore().collection('users').doc(firebase.auth().currentUser.uid)
              .collection('entries').doc();
            entries.unshift({
              unsaved: true,
              ref:newEntryRef,
              id: newEntryRef.id,
              data: () => {}
            });
          }
        }

        console.log(entries);

        this.setState({ entries: entries });
      }, error => {
        console.log("Error getting documents: ", error);
      });
  }

  componentWillUnmount() {

  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <AppBar position="static" color="primary">
          <Toolbar>
            <Typography type="title" color="inherit">
              Darwin
            </Typography>
          </Toolbar>
        </AppBar>
        <div className={classes.listView}>
          {this.state.entries.map(entry =>
            <EntryView key={entry.id} doc={entry} />
          )}
        </div>

      </div>
    );
  }
}


JournalView.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(JournalView);



// WEBPACK FOOTER //
// ./src/JournalView.js